// extracted by mini-css-extract-plugin
export var body = "_ca-0";
export var sectionHeader = "_ca-4";
export var shortcutColumns = "_ca-2";
export var shortcutList = "_ca-1";
export var shortcutSection = "_ca-3";